import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Col } from 'react-bootstrap';
import {
  setMainBoardActiveTab, getCrewList, getGeoRegionList,
  getManualLoad, getFieldLoads, refreshDashboard, getWorkedAcres, getGeoOffloadList,
  getSeedLoad, setCrewSelectedPlanType, setFieldSelectedWorkType, setLeaderBoardSelectedWorkType,
  setSelectedCrews, getUserConfiguration, getDashBoardTareLoads
} from '../../../actions/dashboard';
import { isToday } from '../../../helpers/common';
import { getDateRangeInfo } from '../../../actions/analyze';

const TabToggle = (props) => {
  const dispatch = useDispatch()
  const farmId = useSelector(state => state.dashboard.farmId);
  const planPlannedToDate = useSelector(state =>
    farmId && state.analyze.searchParams.plannedTodate[farmId]
      ? state.analyze.searchParams.plannedTodate[farmId] : null
  );

  const isRequestingPlanPlannedToDate = planPlannedToDate ? planPlannedToDate.isRequesting : false;
  // const crewCount = useSelector((state) => Object.keys(state.dashboard.crew.crewListById.filteredPayload).length);
  const fieldCount = useSelector(state => Object.keys(state.dashboard.field.fieldListById.payload).length);
  const offloadListCount = useSelector(state => state.dashboard.offload.list.payload.length);
  const loadCount = useSelector(state => state.dashboard.loads.loadHistory.payload.length);
  const refreshCount = useSelector(state => state.dashboard.refreshCount);
  const activeTab = useSelector(state => state.dashboard.activeTab);
  const { rangeId, range } = useSelector(state => state.analyze.searchParams);
 // const isEnableHarvestProjection = useSelector(state => state.farm.currentFarm.is_harvest_projection_enable);
  const selectedPlanType = useSelector(state => state.plan.selectedPlanType);
  const isAllPlan = useSelector(state => state.plan.isSelectAllPlan);
  const selectedPlanTypeIds = useSelector(state => state.dashboard.crew.selectedPlanTypeIds);
  const crewListById = useSelector(state => state.dashboard.crew.crewListById.filteredPayload);

  const [callFieldApi, setCallFieldApi] = useState(true);
  const [crewCounts, setCrewCount] = useState(0);

  useEffect(() => {
    if (farmId) {
      dispatch(getGeoRegionList({ farmId: farmId }));
      dispatch(getGeoOffloadList(farmId, false, range));
    }
  }, [farmId]);

  useEffect(() => {
    if (farmId) {
      const selectedPlanForCrew = isAllPlan ? selectedPlanTypeIds[0] : selectedPlanType;
      dispatch(getUserConfiguration({ farmId }));
      dispatch(getCrewList({ farmId: farmId, selectedPlanForCrew, selectedPlanType }));

      const dateInfo = dispatch(getDateRangeInfo());

      if (selectedPlanType === 2) dispatch(getSeedLoad({ farmId: farmId, selectedPlanType, ...dateInfo }));
      else dispatch(getManualLoad({ farmId: farmId, selectedPlanType, ...dateInfo }));
      const fieldSelectedPlanTypeId = selectedPlanType === 1 ? 8 : selectedPlanType === 2 ? 6 : selectedPlanType === 3 ? 7 : 2;
      const leaderBoardSelectedPlantypeId = selectedPlanType === 2 ? [1, 6] : [1, 2];
      dispatch(setCrewSelectedPlanType([selectedPlanType]));
      dispatch(setFieldSelectedWorkType([fieldSelectedPlanTypeId]));
      dispatch(setLeaderBoardSelectedWorkType(leaderBoardSelectedPlantypeId));
      !callFieldApi && setCallFieldApi(true);

    }
  }, [farmId, rangeId, selectedPlanType]);

  useEffect(() => {
    dispatch(setSelectedCrews([]));
  }, [selectedPlanType])

  useEffect(() => {
    let filteredCrew = [];
    for (const crewId in crewListById) {
      if (crewId && crewListById[crewId] && selectedPlanType !== 10) {
        if (crewListById[crewId].plan_type_id === selectedPlanType)
          filteredCrew.push(crewId);
      } else filteredCrew.push(crewId);
    }
    setCrewCount(filteredCrew.length);

  }, [crewListById, selectedPlanType])

  useEffect(() => {
    !callFieldApi && setCallFieldApi(true);
  }, [isRequestingPlanPlannedToDate, refreshCount]);

  useEffect(() => {
    if (activeTab === "fields" && callFieldApi) {
      getFieldsDetails();
      setCallFieldApi(false);
    }
  }, [activeTab, callFieldApi]);

  const getFieldsDetails = () => {
    const cb = (dateInfo) => {
      const params = { farmId, ...dateInfo, selectedPlanType };
      const dataRange = {
        range: (selectedPlanType && selectedPlanType === 2) ? 'custom' : 'todate',
        fromDate: dateInfo.fromDate,
        toDate: dateInfo.toDate
      }
      const reqParams = { farmId, ...dataRange, selectedPlanType };

      dispatch(getWorkedAcres(params));
      dispatch(getFieldLoads(reqParams));
      dispatch(getDashBoardTareLoads({ is_tareload: true, ...reqParams }))
    };

    dispatch(getDateRangeInfo({ farmId }, cb));
  };

  const setActiveTab = (type) => {
    if (isToday(range)) dispatch(refreshDashboard());
    dispatch(setMainBoardActiveTab(type));
    props.history.push(`${props.match.url}/${type}?sub=1`);
  };

  return <Col className="d-flex header-toggle-btn">
    <div className={`btn-name ${activeTab === "crews" && "active"}`} onClick={() => setActiveTab("crews")} title={"Crews"}>Crews
      <span className="count">{crewCounts}</span>
    </div>
    <div className={`btn-name ${activeTab === "fields" && "active"}`} onClick={() => setActiveTab("fields")} title={"Fields"}>Fields
      <span className="count">{fieldCount}</span>
    </div>
    <div className={`btn-name ${activeTab === "Offload" && "active"}`} onClick={() => setActiveTab("Offload")} title={"Offload"}>Offload site
      <span className="count">{offloadListCount}</span>
    </div>
    <div className={`btn-name ${activeTab === "loads" && "active"}`} onClick={() => setActiveTab("loads")} title={"Loads"}>Loads
      <span className="count">{loadCount}</span>
    </div>
  </Col>;
};

export default TabToggle;
